<template>
    <app-chart-wrapper>
      <div class="card">
        <div class="card-left-side">
          <div class="interaction-wrapper">
              <interactions-preview :data-interaction="interaction"
                                    isStatisticsPreview/>
          </div>
        </div>
  
        <div class="stats">          
  
          <div class="chart-footer">            
  
            <ul class="doughnut-footer">
              <li>
                <div></div>
                <div class="label">
                  <div>{{$t('message.statistics.message.screenTime')}}:</div>
                </div>
                <div></div>
                <div class="text-sm text-right ">
                  <div>{{screenTime}}s</div>
                </div>
  
              </li>
            </ul>
  
            <ul class="doughnut-footer">
              <li>
                <div></div>
                <div class="label">
                  <div>{{$t('message.statistics.message.engagement')}}:</div>
                </div>
                <div></div>
                <div class="text-sm text-right ">
                  <div class="text-success">{{engagement}}%</div>
                </div>
  
              </li>
            </ul>
            <ul class="doughnut-footer">
              <li>
                <div></div>
                <div class="label">
                  <div>{{$t('message.statistics.message.rejection')}}:</div>
                </div>
                <div></div>
                <div class="text-sm text-right ">
                  <div class="text-danger">{{rejection}}%</div>
                </div>
  
              </li>
            </ul>
          </div>
  
        </div>
      </div>
    </app-chart-wrapper>
  </template>
  
  <script>
  import interactionStat from "./interaction-stat";
  import colors from "@packages/colors";
  import AppChartWrapper from "@components/chart/ChartWrapper";
  import InteractionsPreview from "@views/advertising/components/preview/InteractionsPreview";
  import EventBus from "@packages/event-bus/index";
  import _ from "lodash";
  
  export default {
    mixins: [interactionStat],
  
    components: {
      AppChartWrapper,
      InteractionsPreview
    },
  
    data() {
      return {
        chartBackground: colors.charts.doughnut,
      };
    },
    computed: {
      total() {
        return _.sum(this.data.datasets[0].data);
      },
    },
    methods: {
      color(index) {
        return colors.charts.doughnut[index];
      },
  
      datasetItemValue(index) {
        if (!this.data.datasets) return;
  
        return this.data.datasets[0].data[index];
      },
  
      percentage(value) {
        return this.total !== 0 ? Math.round((value / this.total) * 100) : 0;
      },
  
      openModalAnswersFromChart(event, element) {
        let dataAnswer = {
          mode: this.mode,
          interactionId: this.stats.interactionBody.id,
          advertisingId: this.stats.campaignId,
          answer: element[0]._model.label,
          answers: this.data.labels,
        };
        EventBus.$emit("OPEN_MODAL_ANSWERS", dataAnswer);
      },
  
      openModalAnswers(label) {
        let dataAnswer = {
          mode: this.mode,
          interactionId: this.stats.interactionBody.id,
          advertisingId: this.stats.campanhaId,
          answer: label,
          answers: this.data.labels,
        };
        EventBus.$emit("OPEN_MODAL_ANSWERS", dataAnswer);
      },  
      
    },  
    
  };
  </script>
  
  <style lang="scss" scoped>
  @import "~@variables";
  
  .card {
    display: flex;
    align-items: center;
  
    .stats {
      width: 50%;
      align-self: flex-start;
  
      .select-wrapper {
        display: flex;
        justify-content: flex-end;
      }
  
      .chart {
        margin: 12px 0 12px 0;
      }
  
      .chart-footer {
        display: flex;
        flex-direction: column;
  
        .flex-justify-end {
          margin-left: auto;
          padding-right: 10%;
        }
      }
  
      ul {
        li {
          margin: 14px 40px 0 30px;
        }
      }
    }
  
    .card-left-side {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 420px;
      width: 40%;
  
      .interaction-wrapper {
        .interaction {        
          /* position: absolute;
          top: 30%;
          right: 35%; */
          pointer-events: none;
          transform: scale(0.7);
        }
      }
    }
  
    @media (max-width: 1800px) {
      .card-left-side {
  
        .interaction-wrapper {
          .interaction {
            pointer-events: none;
            transform: scale(0.6);
          }
        }
      }
    }
  
    @media (max-width: 1700px) {
      font-size: 14px;
  
      .card-left-side {
        height: 330px;
        width: 45%;
  
        .interaction-wrapper {
          .interaction {          
            pointer-events: none;
            transform: scale(0.5);
          }
        }
      }   
  
    }
  
    @media (max-width: 1400px) {
      font-size: 14px;
  
      .card-left-side { 
        .interaction-wrapper {
          .interaction {          
            pointer-events: none;
            transform: scale(0.7);
          }
        }
      }   
  
    }
  }
  
  li {
    width: 100%;
    display: grid;
    grid-template-columns: 30px auto auto 40px;
    font-size: 16px;
    &:not(:first-child) {
      margin-top: 14px;
    }
  
    > * {
      display: flex;
      align-items: center;
    }
  
    .circle {
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: 3px solid;
    }
  
    .label {
      margin-right: 6px;      
    }
  
    @media (max-width: 1700px) {
      font-size: 14px;
    }
  }
  </style>
  